import React from 'react';
import { Field, Select } from '@zendeskgarden/react-forms';
import type { ZenComboboxProps } from './interface';

export function ZenCombobox({
  label,
  placeholder,
  options,
  onChange,
  disabled,
  value,
}: ZenComboboxProps) {
  return (
    <Field>
      {label && <Field.Label>{label}</Field.Label>}
      <Select
        disabled={disabled}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
          onChange?.(event.target.value);
        }}
      >
        {/* Placeholder como uma opção desabilitada ou padrão */}
        {placeholder && <option value="" disabled hidden>{placeholder}</option>}
        
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </Select>
    </Field>
  );
}